import { useState } from 'react';

export const BlockStatus = (props) => {
    const status = props.status;
    const bkg = props.bkg;
    const [show, setShow] = useState('hide');
    switch (status) {
        case 'Disable':
            return (
                <>
                    <div className={`icon-status ${bkg}`} title="Archive" onClick={() => { show === 'hide' ? setShow('show') : setShow('hide'); }}>
                        <i className="fa fa-database" aria-hidden="true"></i>
                    </div>
                    <div className={`bolo ${bkg} ${show}`} onClick={() => { show === 'show' ? setShow('hide') : setShow('show'); }}>
                        <div className="icon"><i className="fa fa-database" aria-hidden="true"></i></div>
                        <div className="title">ARCHIVE</div>
                        <div className="text">
                            Cette attraction fait maintenant partie des archives et n'est plus présente 
                            dans les parcs «Disneyland Resort Paris».
                        </div>
                    </div>

                </>
            )
        default:
            return (
                <></>
            )
    }
}